import { call, put, StrictEffect, takeLatest } from 'redux-saga/effects';
import fetchAPI from '@utils/fetchAPI';
import DomainByEnv from '@utils/domainByEnv';
import * as actionTypes from '../actionTypes';
import * as actions from '../actions';
import { I_RecommendAction } from '../actions';

const detailRoute = `${DomainByEnv()}/detail`;

function* setRecommendAsync(action: I_RecommendAction): Generator<StrictEffect, any, any> {
    const recommends = yield call(fetchAPI, {
        url: `${detailRoute}/popularinfojson`,
        req: action.payload,
    });
    yield put(actions.setRecommendsSUCCESS(recommends));
}

function* watchSetRecommendAsync() {
    yield takeLatest(actionTypes.SET_RECOMMENDS, setRecommendAsync);
}

export default [watchSetRecommendAsync()];
